import { LoadingState } from "@/components/ui-template/LoadingState";

export const RouteFallback = () => {
  return (
    <LoadingState
      variant="page"
      message="Đang tải…"
    />
  );
};
